<template>
  <md-card
    class="dynamic-card"
    :class="{ 'transparent-card': transparentCard }"
  >
    <md-card-header :class="{ 'no-spacement-header': transparentCard }">
      <md-card-header-text>
        <div class="title-container">
          <h2
            v-if="titleAction"
            class="title-action"
            @click="titleAction"
          >
            {{ title }}
          </h2>
          <h2 v-else>
            {{ title }}
          </h2>

          <ButtonDropdownDefault
            v-if="title === 'Rastreabilidade - produção'"
            selected-option=""
            icon="icon-more"
            :it-may-change-selected-option="false"
            :initial-options="dropdownOptions"
            @option-selected="handleSelectedOption"
          />
        </div>
        <h3>
          {{ subtitleRegular }}
          <span
            v-if="subtitleHighlight"
            class="bold"
          >{{
            subtitleHighlight
          }}</span>
          <md-tooltip v-if="subtitleRegular">
            {{ subtitleRegular }}
            <span v-if="subtitleHighlight">{{ subtitleHighlight }}</span>
          </md-tooltip>
        </h3>
      </md-card-header-text>
    </md-card-header>
    <md-card-content v-if="slotEnabled">
      <slot />
    </md-card-content>
    <md-card-actions
      v-if="buttons"
      :class="{ barchartcard: title === 'Rastreabilidade - produção' }"
    >
      <template v-if="title === 'Rastreabilidade - produção'">
        <div>
          <div class="download-btn">
            <button
              v-if="buttons[0].visible"
              :id="buttons[0].id"
              :key="'button' + buttons[0].action"
              class="btn-small button"
              :class="buttons[0].style + buttonWidth(buttons[0].halfWidth)"
              @click="go(buttons[0].action)"
            >
              {{ buttons[0].text }}
            </button>
          </div>
        </div>
      </template>
      <template v-if="title !== 'Rastreabilidade - produção'">
        <template v-for="button in buttons">
          <button
            v-if="button.visible"
            :id="button.id"
            :key="'button' + button.action"
            class="btn-small button"
            :class="button.style + buttonWidth(button.halfWidth)"
            @click="go(button.action)"
          >
            {{ button.text }}
          </button>
        </template>
      </template>
    </md-card-actions>
  </md-card>
</template>

<script>
import ButtonDropdownDefault from '@/components/common/buttonComponent/ButtonDropdownDefault.vue'

export default {
  name: 'Card',
  components: {
    ButtonDropdownDefault
  },
  props: {
    title: String,
    titleAction: Function,
    subtitleRegular: String,
    capitalizeSubtitle: {
      type: Boolean,
      default: false
    },
    transparentCard: {
      type: Boolean,
      default: false
    },
    subtitleHighlight: String,
    buttons: Array,
    settingsButtonEnabled: {
      type: Boolean,
      default: true
    },
    slotEnabled: {
      type: Boolean,
      default: true
    },
    dropdownOptions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    go(action) {
      this.$emit('btnClickAction', action)
    },
    buttonWidth: function (width) {
      return !width ? ' button--full' : ' button--half'
    },
    handleSelectedOption(option) {
      this.$emit('click', option.action);
    }
  }
}
</script>

<style lang="scss" scoped>
.md-card-actions.barchartcard {
  padding: 0 !important;
  margin: 0 !important;
}

.download-btn {
  padding: 0 15px;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
}

.md-card-actions.barchartcard button {
  margin: 0;
  margin-bottom: 14px !important;
}

.barchartcard .btn-row {
  border-top: 1px solid #ddd;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
    margin-top: 20px;
  }
}

.md-card-actions.barchartcard>div {
  width: 100%;
}

.barchartcard .btn-row button:nth-of-type(2n) {
  border-left: 1px solid #ddd;
  margin: 0 !important;
}

.barchartcard .btn-row button {
  width: 100%;
  height: 42px;
  display: flex;
  border-radius: 0;
  margin: 0 !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

.barchartcard .btn-row div i {
  margin-right: 5px;

  @media (max-width: 1200px) {
    display: none;
  }
}

.dynamic-card {
  border-radius: 6px;
  box-shadow: none;
  overflow: hidden;
  z-index: auto !important;
  flex: 1;
  height: 100%;

  @media (max-width: 1200px) {
    padding: 1rem
  }

  .md-card {
    &-header,
    &-content {
      padding-bottom: 0 !important;
    }

    &-actions {
      margin-top: auto;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: inherit;
      padding: 6px 16px;
      margin-bottom: 6px;

      .button {
        padding: 15px 0;
        font-weight: 580;
        text-transform: uppercase;
        margin-bottom: 2px;
        line-height: 1.2;
        flex-direction: column;
        height: 40px;
        font-size: 13.3px;

        // For IE 11
        @media screen and (-ms-high-contrast: active),
        (-ms-high-contrast: none) {
          flex-direction: row;
        }

        &--half {
          width: 50%;
          min-width: 50%;
          margin: 5px 0px;
          padding: 0;
        }

        &--full {
          width: 100%;

          @media (max-width: 1200px) {
            font-size: 10px;
          }
        }
      }
    }
  }

  h2,
  h3 {
    font-family: 'Exo 2', sans-serif;
    font-style: normal;
    font-weight: 400;
  }

  h2 {
    font-weight: 700;
    font-size: 18px;
    color: #818181;

    @media (max-width: 1200px) {
      font-size: 16px;
      height: 16px;
    }
  }

  h3 {
    font-size: 12px;
    color: #7a7a7a;

    :first-letter {
      text-transform: capitalize;
    }
  }

  .title-action {
    cursor: pointer;
    display: table;
  }

  .bold {
    font-weight: bold;
  }

  &.transparent-card {
    background-color: transparent !important;
  }

  .no-spacement-header {
    padding-top: 0px !important;
  }

  .md-card-header-text {
    @media (max-width: 1200px) {
      width: 100%;
    }
  }
}

@media(max-width: 600px) {
  .md-card {
    padding-bottom: 10px;
    .md-card-content {
      padding: 0 10px;
    }

    .md-card-header {
      padding: 0 10px;

      h2 {
        font-size: 14px;
      }
    }
  }
}
</style>
